/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rapid_Eager_Otter_DanceInputs */

const fr_rapid_eager_otter_dance = /** @type {(inputs: Rapid_Eager_Otter_DanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annulé`)
};

/**

* @param {Rapid_Eager_Otter_DanceInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const rapid_eager_otter_dance = /** @type {((inputs?: Rapid_Eager_Otter_DanceInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rapid_Eager_Otter_DanceInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_rapid_eager_otter_dance(inputs)
});